<script>
import {productMethods, authComputed} from "@state/helpers";
import VueShowMoreText from 'vue-show-more-text'
import Moment from "moment";

export default {
  components: { VueShowMoreText },
  data() {
    const trackers = []
    const trackersCount = 10;
    for (let i = 0; i < trackersCount; i += 1) {
      trackers.push({slot: i + 1})
    }
    return {
      trackers,
      expandedText: {},
      urlToAdd: null,
      tryingToAdd: false,
      placeholders: {
        urlToAdd: 'Enter a product URL here to add a custom tracker for it'
      },
      headers: [
        {
          text: 'Slot',
          value: 'slot',
          width: '100px',
        },
        {
          text: 'Name',
          value: 'listing.name',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Expires',
          value: 'expires'
        },
        {
          text: 'Actions',
          value: 'actions'
        },
      ],
    }
  },
  computed: {
    ...authComputed,
    avatarClasses() {
      return `ma-3 ${this.$style.avatar}`
    }
  },
  mounted() {
    if (!this.currentUser) {
      return
    }

    const vm = this
    this.getCustomTrackers().then(data => {
      const newTrackers = []
      for (let i = 0; i < vm.trackers.length; i += 1) {
        if (data.trackers.length - 1 >= i) {
          newTrackers.push(data.trackers[i])
        } else {
          newTrackers.push(vm.trackers[i])
        }
      }
      vm.trackers = newTrackers

      console.log(vm.trackers)
    })
  },
  methods: {
    ...productMethods,
    calculateTimestamp(timestamp) {
      if (!timestamp) {
        return ''
      }
      return `in ${new Moment(parseInt(timestamp)).diff(new Moment(), 'days')} days`
    },
    listingImage(item) {
      if (!item.listing || !item.listing.image) {
        return null
      }

      return item.listing.image
    },
    tryDeleteTracker(item) {
      this.deleteTracker(item).then(() => {
        window.location.reload()
      })
    },
    tryCreateTracker() {
      try {
        if (!this.urlToAdd) {
          return
        }

        const url = new URL(this.urlToAdd)
        this.tryingToAdd = true
        const vm = this
        this.addTracker({url}).then(() => {
          this.$swal.fire({
            title: 'Success',
            text: 'This custom tracker has been created. It may take a few minutes to finish setup.',
            icon: 'success'
          })
        }).catch(err => {
          let title = 'Error!'
          let message = 'An error occurred while creating this tracker'
          let icon = 'error'
          if (err && err.response && err.response.data) {
            message = err.response.data.error || err.response.data.warning
            title = err.response.data.title || title

            if (err.response.data.warning) {
              icon = 'warning'
            }
          }

          this.$swal.fire({
            title,
            text: message,
            icon
          })
        }).finally(() =>{
          vm.tryingToAdd = false
        })
      } catch (err) {
        // Ignore
      }
    }
  }
}
</script>

<template>
  <div>
    <BaseInputText
        v-model="urlToAdd"
        name="urlToAdd"
        type="text"
        :placeholder="placeholders.urlToAdd"
    />
    <BaseButton :disabled="tryingToAdd" type="button" @click="tryCreateTracker">
      <BaseIcon v-if="tryingToAdd" name="sync" spin />
      <span v-else>
            Create Tracker
          </span>
    </BaseButton>

    <v-data-table
        :headers="headers"
        :items="trackers"
        :items-per-page="20"
        class="elevation-1"
    >
      <v-progress-linear
          slot="progress"
          color="cyan"
          indeterminate
      ></v-progress-linear>
      <template v-slot:[`item.slot`]="{ item }">
        <span>{{ item.slot }}</span>
      </template>
      <template v-slot:[`item.listing.name`]="{ item }">
        <a :href="item.url" target="_blank">
          <v-avatar :class="avatarClasses" size="125" tile>
            <v-img v-if="!listingImage(item)" src="@assets/images/default_product_image.jpg"></v-img>
            <v-img v-else :src="listingImage(item)"></v-img>
          </v-avatar>
        </a>
        <VueShowMoreText
            v-if="item.listing"
            :text="item.listing.name"
            :lines="1"
            additional-container-css="margin:14px;"
            additional-content-css="font-size:16px;"
            additional-content-expanded-css="font-size:16px;"
            additional-anchor-css="font-size: 16px;"
            @click="expandedText[item.listing.name]"
        />
        <span v-else>Open</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>{{ item.status }}</span>
      </template>
      <template v-slot:[`item.expires`]="{ item }">
        {{ calculateTimestamp(item.expires) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <a v-if="item.id" href="#" @click="tryDeleteTracker(item)">Delete</a>
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.avatar {
  div {
    background-size: contain !important;
  }
}

</style>
